exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".side{background:#286e67;background:-webkit-gradient(left top,right bottom,color-stop(0,#286e67),color-stop(100%,#61e295));background:linear-gradient(135deg,#286e67,#61e295);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#286e67\",endColorstr=\"#61e295\",GradientType=1);background-size:cover;min-height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f3aed95","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Side.vue
// module id = aSWw
// module chunks = 1